/* unplugin-vue-components disabled */import { render } from "./persona.vue?vue&type=template&id=c05c8520&scoped=true"
import script from "./persona.vue?vue&type=script&setup=true&lang=js"
export * from "./persona.vue?vue&type=script&setup=true&lang=js"

import "./persona.vue?vue&type=style&index=0&id=c05c8520&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05c8520"],['__file',"src/components/cards-v2/persona/persona.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c05c8520"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c05c8520', __exports__)) {
    api.reload('c05c8520', __exports__)
  }
  
  module.hot.accept("./persona.vue?vue&type=template&id=c05c8520&scoped=true", () => {
    api.rerender('c05c8520', render)
  })

}


export default __exports__